import { LEAVE_TYPE_LABELS } from '../../../utils/leaveBalance';

// İzin türleri kayıtta kodla tutulur; çalışan bu üçünü talep edebilir
export const REQUESTABLE_LEAVE_TYPES = ['yillik', 'mazeret', 'raporlu'];

/** Ekranda izin türünün adı; bilinmeyen kod verilen yedek metinle (ya da kendisiyle). */
export const leaveTypeLabel = (t, typeKey, fallback) => (
  typeKey && LEAVE_TYPE_LABELS[typeKey]
    ? t(`profilePage.leave.types.${typeKey}`)
    : (fallback || typeKey || '')
);

export const LEAVE_STATUS_TONES = {
  PENDING: 'warning',
  APPROVED: 'success',
  REJECTED: 'danger',
};
